import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

const ImplementationIcon = () => {
  return (
    <span className="implementation-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <motion.g
          animate={{
            y: [0, 1.1, 1.1, 1.1, 1.1, 1.1, 1.1, 1.1, 1.1, 0, 0, 0],
            rotate: [0, 4, -4, 4, -4, 4, -4, 4, -4, 0, 0, 0],
            scale: [1, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 1, 1, 1],
          }}
          transition={{
            ease: "linear",
            times: [
              0, 0.02, 0.04, 0.06, 0.08, 0.1, 0.12, 0.14, 0.16, 0.18, 0.2, 1,
            ],
            duration: 6,
            repeat: Infinity,
          }}
        >
          <g id="box_bottom">
            <path
              className="cls-4"
              d="M21.68,48H3.1c-.86,0-1.55-.79-1.55-1.77v-23.92h44.9v23.92c0,.98-.69,1.77-1.55,1.77h-18.58"
            />
          </g>
          <motion.g
            animate={{
              y: [0, 0, 17.4, 17.4, 0, 0, 0],
              x: [0, 0, 6, 6, 0, 0, 0],
              rotate: [0, 0, 40, 40, 0, 0, 0],
              scale: [1, 1, 0.8, 0.8, 1, 1, 1],
            }}
            transition={{
              ease: "easeInOut",
              times: [0, 0.15, 0.3, 0.35, 0.8, 0.9, 1],
              duration: 6,
              repeat: Infinity,
            }}
          >
            <motion.g
              animate={{
                x: [0, -2, 2, -2, 2, 0, 0],
              }}
              transition={{
                ease: "easeInOut",
                times: [0, 0.1, 0.15, 0.2, 0.25, 0.3, 1],
                duration: 6,
                repeat: Infinity,
              }}
            >
              <g id="shape_left">
                <path
                  className="cls-4"
                  d="M24,6.92c0-3.82-3.12-6.92-6.97-6.92s-6.97,3.1-6.97,6.92,3.12,6.92,6.97,6.92h6.97v-6.92Z"
                />
              </g>
              <g id="shape_right">
                <path
                  className="cls-3"
                  d="M24,8.46c0-2.97,2.43-5.38,5.42-5.38s5.42,2.41,5.42,5.38-2.43,5.38-5.42,5.38h-5.42v-5.38Z"
                />
              </g>
            </motion.g>
            <g id="box_top">
              <path
                className="cls-1"
                d="M29.42,13.84h17.03c.86,0,1.55.69,1.55,1.54v6.92H0v-6.92c0-.85.69-1.54,1.55-1.54h27.87Z"
              />
            </g>
          </motion.g>
          <g id="box_center">
            <motion.rect
              className="cls-2"
              x="21.68"
              y="13.84"
              width="4.65"
              height="34.16"
              animate={{
                y: [0, 34.16, 34.16, 34.16, 0, 0],
                height: [34.16, 0, 0, 0, 34.16, 34.16],
              }}
              transition={{
                ease: "easeInOut",
                times: [0, 0.2, 0.7, 0.8, 1],
                duration: 6,
                repeat: Infinity,
              }}
            />
          </g>
        </motion.g>
      </svg>
    </span>
  )
}

export default ImplementationIcon
